<template>
  <OrderPackingDetail label="Susulan Promo" type="free_reimbursement" :index-path="indexPath" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail },
  props: {
    indexPath: String
  }
}
</script>